import detectMobileDevice from 'is-mobile';
import { action, computed, observable } from 'mobx';

import { CHAT_WINDOW_MODE_DEFAULT } from '../utilities';

export default class UIStore {
  constructor(rootStore) {
    this.rootStore = rootStore;
    this.addResizeListener();
  }

  @observable isMobile = detectMobileDevice();

  @observable isOpenedTranscript = false;

  @observable isVisibleExtraHeaderFilter = false;

  @observable isHeaderClassicView = false;

  @observable isMessageInputDisabled = false;

  @observable isVisibleLiveChatButton = false;

  @observable isJsonSelectOpened = false;

  @observable.struct windowSize = {
    width: window.innerWidth,
    height: window.innerHeight
  };

  @action addResizeListener() {
    let timeout = 0;

    window.addEventListener('resize', () => {
      if (timeout) {
        window.clearTimeout(timeout);
      }

      timeout = window.setTimeout(() => {
        this.windowSize = {
          width: window.innerWidth,
          height: window.innerHeight
        };
      }, 100);
    });
  }

  @action setOpenTranscript(isOpened) {
    this.isOpenedTranscript = isOpened;
  }

  @action showExtraHeaderFilter(isVisible) {
    this.isVisibleExtraHeaderFilter = isVisible;
  }

  @action setHeaderClassicView(isClassicView) {
    this.isHeaderClassicView = isClassicView;
  }

  @action setMessageInputDisabled(value) {
    this.isMessageInputDisabled = value;
  }

  @computed get isVisibleExtraHeader() {
    if (
      this.isMobile ||
      !this.rootStore.config.header.classicView ||
      !this.rootStore.config.header.avatar.enabled ||
      (this.rootStore.config.overlapMenu && this.rootStore.config.overlapMenu.enabled) ||
      this.rootStore.chatWindow.dimensions.height === this.windowSize.height
    ) {
      return false;
    }

    return (
      this.rootStore.chatWindow.isDefault ||
      (this.rootStore.chatWindow.isAnimating &&
        this.rootStore.chatWindow.prevMode === CHAT_WINDOW_MODE_DEFAULT)
    );
  }

  // OverlapMenu
  @observable isHomeButton = false;

  @observable isBackButton = false;

  @observable isOpenOverlapMenuModal = false;

  @observable isStartChatWithoutCategory = false;

  @observable category = {
    id: 0,
    name: '',
    isCleared: false
  };

  @observable project = {
    id: 0,
    projectId: 0,
    source: '',
    isSelected: false
  };

  @computed get isOverlapMenuInputDisabled() {
    if (
      !this.category.id &&
      this.rootStore.config.overlapMenu &&
      !this.rootStore.config.overlapMenu.options.messageInputEnabled
    ) {
      return true;
    }
    return false;
  }

  @computed get isVisibleMessageInput() {
    if (this.category.id || this.isOpenOverlapMenuModal || this.isStartChatWithoutCategory) {
      return true;
    }
    return false;
  }

  @action setOverlapMenuModal(state) {
    this.isOpenOverlapMenuModal = state;
    this.isHomeButton = state;
  }

  @action closeOverlapMenuModal() {
    this.isOpenOverlapMenuModal = false;
    this.isHomeButton = false;
    this.isBackButton = false;
    this.isStartChatWithoutCategory = false;
    this.rootStore.chat.clearMessages();
    this.rootStore.bot.setParentCategoryId(0);
    if (this.category.id) {
      this.category.id = 0;
      this.category.name = '';
    }
  }

  @action closeHeaderMenuModal() {
    this.rootStore.bot.setParentCategoryId(0);
    if (this.category.id) {
      this.category.id = 0;
      this.category.name = '';
    }
  }

  @action setCategory(id, name) {
    this.category.id = id;
    this.category.name = name;
    if (this.category.id) {
      this.isHomeButton = true;
      this.isBackButton = true;
    }
  }

  @action setProjectId(id, projectId, source) {
    this.project.id = id;
    this.project.projectId = projectId;
    this.project.source = source;
  }

  @action setProjectSelected() {
    this.project.isSelected = true;
  }

  @action goBack() {
    this.setCategory(0, '');
    this.isBackButton = false;
    this.isStartChatWithoutCategory = false;
    this.rootStore.chat.clearMessages();
    if (!this.isOpenOverlapMenuModal) {
      this.isHomeButton = false;
    }
  }

  @action startChatWithoutCategory() {
    if (
      !this.category.id &&
      this.rootStore.chat.messages.length > 0 &&
      !this.isStartChatWithoutCategory
    ) {
      this.rootStore.bot.topFrequentQuestions = [];
      this.rootStore.ui.isStartChatWithoutCategory = true;
      this.rootStore.ui.isHomeButton = true;
      this.rootStore.ui.isBackButton = true;
    }
  }
}
